import { Component, OnInit, Input } from "@angular/core";
import { BaseComponent } from "../../base.component";

import { SessionManagerService } from "../../_services/SessionManager/session-manager.service";
import { DataService } from "../../_services/data.service";
import { AlertService } from "../../_services/alert.service";

@Component({
  moduleId: module.id,
  selector: "meshutaf-user-form",
  templateUrl: "meshutaf-user-form.component.html",
})
export class MeshutafUserFormComponent extends BaseComponent {
  @Input() user?: any;
  userView: any = [];
  model: any;
  loading = false;
  allowedModel: any = {
    firstName: { visible: true },
    lastName: { visible: true },
    personalId: { visible: true },
    email: { visible: true },
    phone: { visible: true },
    circle: { visible: true },
    county: { visible: true },
    nest: { visible: true },
    jobRole: { visible: true },
    branch: { visible: true },
  };

  constructor(
    public dataService: DataService,
    private alertService: AlertService,
    public sessionManager: SessionManagerService
  ) {
    super(dataService, sessionManager);
  }

  saveUser() {
    // 		this.model.viewer = this.model.userType == 'viewer' ? 1 : 0;
    // 		this.model.isMeshutaf = this.model.userType == 'meshutaf' ? 1 : 0;
    // 		this.model.onlyMobile = this.model.userType == 'mobile' ? 1 : 0;
    this.loading = true;
    this.dataService.saveAdminUser(this.model).subscribe(
      (data) => {
        this.loading = false;
        this.alertService.success("נשמר בהצלחה");
      },
      (error) => {
        this.alertService.error(
          error && error.statusText
            ? decodeURIComponent(error.statusText)
            : error
        );
        this.loading = false;
      }
    );
  }

  // 	clickRadioButton(e){

  // 		if (this.model.userType == $(e.target).val())
  // 			this.model.userType = undefined;
  // 	}

  clickButton(type, e) {
    if (type) {
      if (type == "meshutaf") {
        this.model.isMeshutaf = this.model.isMeshutaf == 1 ? 0 : 1;
        this.model.onlyMobile =
          this.model.isMeshutaf == 1 ? 0 : this.model.onlyMobile;
        this.model.viewer = this.model.isMeshutaf == 1 ? 0 : this.model.viewer;
      } else if (type == "viewer") {
        this.model.viewer = this.model.viewer == 1 ? 0 : 1;
        this.model.isMeshutaf =
          this.model.viewer == 1 ? 0 : this.model.isMeshutaf;
      } else if (type == "mobile") {
        this.model.onlyMobile = this.model.onlyMobile == 1 ? 0 : 1;
        this.model.isMeshutaf =
          this.model.onlyMobile == 1 ? 0 : this.model.isMeshutaf;
      }
    }
    e.preventDefault();
    e.stopPropagation();
  }

  run() {
    // 		this.setUser();
  }

  setUser(user?: any) {
    this.user = user;
    this.userView = [];
    this.model = this.user;
    if (this.user) {
      // 			this.model.userType = this.user.isMeshutaf ? 'meshutaf' : (this.user.onlyMobile ? 'mobile' : (this.user.viewer ? 'viewer' : undefined));
      for (let key in this.user) {
        if (this.allowedModel[key]) {
          this.userView.push({
            label: key + "_field",
            value: this.user[key],
          });
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/meshutaf-users/meshutaf-user-form.component.ts